import React from "react";

const Footer = () => {


    return(
        <div className="footer">Powerd by Jay @ 2024</div>
    )
}

export default Footer